import { Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { debounceTime } from 'rxjs';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { Tc } from 'src/app/components/core/_infrastructure/types/common';
import { FilterSearchingTCampaniaEspecificaViewModel } from '../campaniaespecifica.types';

@Component({
    selector: 'app-campaniaespecifica-filter',
    templateUrl: './campaniaespecifica-filter.component.html',
    styleUrls: ['./campaniaespecifica-filter.component.scss'],
})
export class CampaniaEspecificaFilterComponent extends ComponentBase implements OnInit {
    @Input() paises: Tc[];
    @Input() modelosCf: Tc[];
    @Input() idiomas: Tc[];
    @Input() lastFilter: FilterSearchingTCampaniaEspecificaViewModel;
    @Output() search = new EventEmitter<FilterSearchingTCampaniaEspecificaViewModel>();
    @Output() cleanForm = new EventEmitter<any>(); // Informa que el formulario se ha reseteado

    isCollapsed = false;

    constructor(
        private fb: FormBuilder,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.createForm();
        this.recoverLastSearch();
    }

    /**
     * Creación del formulario de búsqueda.
     * @return void
     */
    private createForm(): void {
        this.form = this.fb.group({
            Descripcion: '',
            IdPais: null,
            IdModeloCf: null,
            IdIdioma: null,
        });
    }

    /**
     * Recover last search from the previous payload
     */
    private recoverLastSearch(): void {
        if (this.lastFilter) {
            this.form.setValue({
                Descripcion: this.lastFilter.Descripcion,
                IdPais: this.lastFilter.IdPais,
                IdModeloCf: this.lastFilter.IdModeloCf,
                IdIdioma: this.lastFilter.IdIdioma,
            });
            this.form.markAsDirty();

            setTimeout(() => {
                this.onSearch(null);
            }, 200);
        }

        // As soon as the user changes the "filter", the previous lastFilter pagination values has no sense
        this.form.valueChanges.pipe(debounceTime(500)).subscribe(values => {
            if (values) {
                this.clearPaginationFilter();
            }
        });
    }

    /**
     * Manejador del evento de reseteo del formulario de búsqueda.
     * @param $event any
     * @return void
     */
    resetForm($event: any): void {
        $event?.stopPropagation();
        this.form.setValue({
            Descripcion: '',
            IdPais: null,
            IdModeloCf: null,
            IdIdioma: null,
        });
        this.form.markAsPristine();

        this.searchingButton = false;
        this.isCollapsed = false;

        this.cleanForm.emit();
    }

    /**
     * We don't clear the whole filter but only the fields related to the pagination.
     */
    private clearPaginationFilter() {
        if (!this.lastFilter) {
            return;
        }
        this.lastFilter.PageNumber = 0;
        this.lastFilter.Asc = 0;
        this.lastFilter.OrderBy = '';
    }

    /**
     * Manejador del evento de búsqueda.
     * @param $event any
     * @return void
     */
    onSearch($event: any): void {
        $event?.stopPropagation();
        this.searchingButton = true;
        this.isCollapsed = true;

        const payload: FilterSearchingTCampaniaEspecificaViewModel = {
            ...this.form.value,
            PageNumber: this.lastFilter?.PageNumber || 0,
            Asc: this.lastFilter?.Asc || 0,
            OrderBy: this.lastFilter?.OrderBy || '',
        };

        this.search.emit(payload);
    }

    /**
     * Para controlar si el formulario ha sido modificado.
     * @returns boolean
     */
    formIsUntouched(): boolean {
        return this.form.pristine || !this.form.dirty;
    }

    /**
     * Getter para controlar la propiedad disabled del botón de búsqueda.
     */
    get disableSearchBtn(): boolean {
        return this.isCollapsed || !this.paises || this.paises?.length == 0 || !this.modelosCf || this.modelosCf?.length == 0;
    }
}
